import React, { Fragment, useState } from 'react';
import { TextField, Typography, Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from '../../../../component/cards/MainCard';

const TextInput = ({ data }) => {
    return (
        <MainCard
            title={data.questionNumber ? `Questão ${data.questionNumber}` : null}
            sx={{ mb: 2 }}
        >
            <Box sx={{ p: 3 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
                            {data.value}
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Campo de resposta curta"
                            defaultValue={data.answer || ''}
                            disabled
                        />
                    </Grid>
                </Grid>
            </Box>
        </MainCard>
    );
};

TextInput.propTypes = {
    data: PropTypes.object.isRequired,
    onInputChange: PropTypes.func
};

export default TextInput;
